import { render } from "./ProductGroupItemForm.vue?vue&type=template&id=a613d46c"
import script from "./ProductGroupItemForm.vue?vue&type=script&lang=js"
export * from "./ProductGroupItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__